/**
 * A player's name as the screen shows it: "First Last". Names arrive in both
 * forms: omnibus and the game service store "Last, First", and roster players
 * are built "First Last". A name without a comma is shown as it is. Split at
 * the first comma, like parseKnownName.
 */
export const formatPlayerName = (name: string | null | undefined) => {
  const trimmed = name?.trim() ?? "";
  const comma = trimmed.indexOf(",");
  if (comma === -1) return trimmed;
  const last = trimmed.slice(0, comma).trim();
  const first = trimmed.slice(comma + 1).trim();
  return [first, last].filter(Boolean).join(" ");
};
